import { api_react_v1_powerlist_header_path, api_react_v1_powerlist_path } from '../../routes';
import request from './request';

export interface PowerlistPersonData {
  rank: number;
  name: string;
  firm: string;
  value?: string;
  extra_credit?: string;
  key_exits?: string;
  key_active_investments?: string;
  description: string;
  notes?: string;
  source?: string;
  photo: string;
  type: string;
  article_title?: string;
  article_url?: string;
}

export interface PowerlistPersonDetails extends PowerlistPersonData {
  rowNum: string;
}

export interface PowerlistData {
  executives: PowerlistPersonData[];
  investors: PowerlistPersonData[];
  emerging: PowerlistPersonData[];
}

export interface PowerlistHeaderData {
  title: string;
  byline: string;
  description: string;
  articleSlug?: string;
}

export async function fetchPowerlistData(
  powerlistType: 'crypto' | 'enterprise'
): Promise<PowerlistData> {
  const resp = await request('get', api_react_v1_powerlist_path(powerlistType));
  return resp;
}

export async function fetchPowerlistHeaderData(
  powerlistType: 'crypto' | 'enterprise'
): Promise<PowerlistHeaderData> {
  const resp = await request('get', api_react_v1_powerlist_header_path(powerlistType));
  return resp;
}
